var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSponsor5(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 101,
    height: 41,
    viewBox: "0 0 101 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Marvel svg",
    clipPath: "url(#clip0_2_8883)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M100.915 0.5H0.915222V40.5H100.915V0.5Z",
    fill: "#EC1D24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M97.9921 31.3461V37.4231H86.7614V3.5769H92.8383V31.3461H97.9921ZM49.9152 20.1923C49.3767 20.4231 48.9152 20.5 48.4537 20.5V9.65383C48.9152 9.65383 52.5306 9.80767 52.5306 15.0384C52.5306 17.7308 51.2998 19.5 49.9152 20.1923ZM32.069 26.8077L33.7614 12.3461L35.5306 26.8077H32.069ZM85.6844 9.73075V3.5769H68.5306L65.6844 24.1923L62.9152 3.5769H56.6844L57.3767 9.03844C56.6844 7.65383 54.146 3.5769 48.5306 3.5769H42.2998V33.5769L37.8383 3.5769H29.6844L24.9921 34.6538V3.5769H17.2998L14.5306 21.0384L11.7614 3.5769H3.99213V37.4231H10.069V21.1154L12.9152 37.4231H16.146L18.9152 21.1154V37.4231H30.6844L31.3767 32.1923H36.146L36.8383 37.4231H48.3767V26.4231L49.7614 26.1923L52.7614 37.4231H58.7614L54.9152 24.3461C56.8383 22.8846 59.0691 19.2692 58.4537 15.7308C58.4537 15.8077 62.069 37.5 62.069 37.5H69.2229L74.069 6.8846V37.4231H85.6075V31.3461H80.146V23.5769H85.6075V17.4231H80.146V9.73075H85.6844Z",
    fill: "#FEFEFE"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    d: "M0.915222 0.5H23.9921V40.5H0.915222V0.5Z",
    fill: "#EC1D24"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    d: "M25.146 37.4231V3.5769H17.2998L14.5306 21.0384L11.7614 3.5769H3.99213V37.4231H10.146V21.1154L12.9152 37.4231H16.146L18.9152 21.1154V37.4231H25.146Z",
    fill: "#FEFEFE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2_8883"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 100,
    height: 40,
    fill: "white",
    transform: "translate(0.915222 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSponsor5);
export default __webpack_public_path__ + "static/media/sponsor 5.f0fb73ea765818a6c6305b67bbc190ab.svg";
export { ForwardRef as ReactComponent };